<vdr-data-table-2
  id="review-list"
  [items]="items$ | async"
  [itemsPerPage]="itemsPerPage$ | async"
  [totalItems]="totalItems$ | async"
  [currentPage]="currentPage$ | async"
  [filters]="filters"
  (pageChange)="setPageNumber($event)"
  (itemsPerPageChange)="setItemsPerPage($event)"
>
  <!-- Adds a search bar -->
  <vdr-dt2-search
    [searchTermControl]="searchTermControl"
    searchTermPlaceholder="Filter by title"
  />

  <vdr-dt2-column
    id="id"
    [heading]="'common.id' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-userPoint="item">
      {{ userPoint.id }}
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    id="createdAt"
    [heading]="'userLevel.entryTime' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-userPoint="item">
      {{ userPoint.createdAt | localeDate : "short" }}
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    id="adjustmentPoint"
    [heading]="'userLevel.adjustmentPoint' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-userPoint="item">
      {{ userPoint.adjustmentPoint }}
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    id="adjustmentAction"
    [heading]="'userLevel.adjustmentAction' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-userPoint="item">
      <vdr-chip
        [colorType]="
          userPoint.pointAction === 'Increase' ? 'success' : 'warning'
        "
      >
        {{
          userPoint.pointAction === "Increase"
            ? ("userLevel.increase" | translate)
            : ("userLevel.decrease" | translate)
        }}
      </vdr-chip>
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    id="order"
    [heading]="'common.order' | translate"
    [hiddenByDefault]="false"
  >
    <ng-template let-userPoint="item">
      <a *ngIf="userPoint.order; else noOrder" class="button-ghost" [routerLink]="['/orders', userPoint.order.id]">
        <span>
          {{ userPoint.order.code }}
        </span>
        <clr-icon shape="arrow right" />
      </a>
      <ng-template #noOrder>
        <span>
          Something here from mission
        </span>
      </ng-template>
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    id="level"
    [heading]="'userLevel.level' | translate"
    [hiddenByDefault]="true"
  >
    <ng-template let-userPoint="item">
      <a
        class="button-ghost"
        [routerLink]="['/extensions/user-level', userPoint.userLevelId]"
      >
        <span>
          {{ userPoint.userLevel.name }}
        </span>
        <clr-icon shape="arrow right" />
      </a>
    </ng-template>
  </vdr-dt2-column>
</vdr-data-table-2>
